module.exports = __webpack_public_path__ + "img/loading.1ac6a3f4.gif";